import { render, staticRenderFns } from "./transaction-allocation-list.vue?vue&type=template&id=07aed9a0"
import script from "./transaction-allocation-list.vue?vue&type=script&lang=js"
export * from "./transaction-allocation-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07aed9a0')) {
      api.createRecord('07aed9a0', component.options)
    } else {
      api.reload('07aed9a0', component.options)
    }
    module.hot.accept("./transaction-allocation-list.vue?vue&type=template&id=07aed9a0", function () {
      api.rerender('07aed9a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/sale-management/sale-stat/transaction-allocation-list.vue"
export default component.exports